// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"WordsMovieButtonGroup_buttonGroup__3rGZI","active":"WordsMovieButtonGroup_active__s5CDV"};